import React, { useState, useEffect, useRef } from 'react';
import { ChevronDown, Sparkles } from 'lucide-react';

const AI_ACTIONS = [
    { key: 'improve', label: '🚀 Improve Content' },
    { key: 'rewrite', label: '🔄 Rewrite Block' },
    { key: 'shorten', label: '✂️ Shorten text' },
    { key: 'expand', label: '📝 Expand Content' },
    { key: 'executive', label: '💼 Executive Tone' },
    { key: 'technical', label: '🛠️ Technical Tone' },
    { key: 'bullets', label: '➔ Convert to Bullets' }
];

const AiActionsDropdown = ({ editor }) => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) setIsOpen(false);
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const handleSelect = async (actionKey) => {
        setIsOpen(false);
        const { from, to } = editor.state.selection;
        let selectedText = editor.state.doc.textBetween(from, to, ' ');
        if (!selectedText) {
            const pos = editor.state.selection.$from;
            selectedText = pos.parent.textContent || '';
        }
        if (!selectedText.trim()) return;

        const prefix = '<strong>[AI Generated Preview]:</strong> ';
        let transformedText = '';
        switch (actionKey) {
            case 'improve':
                transformedText = `<p>${prefix} Here is an optimized, professionally polished version that removes redundant phrases and elevates technical clarity:</p><p style="padding-left:12px; border-left: 2px solid #FF5526;">${selectedText}</p>`;
                break;
            case 'rewrite':
                transformedText = `<p>${prefix} Rewritten dynamically for direct readability:</p><p style="padding-left:12px; border-left: 2px solid #FF5526;">${selectedText}</p>`;
                break;
            case 'shorten':
                transformedText = `<p>${prefix} Condensed for key deliverables:</p><p style="padding-left:12px; border-left: 2px solid #FF5526;">${selectedText.substring(0, 100)}...</p>`;
                break;
            case 'expand':
                transformedText = `<p>${prefix} Expanded version with structured business impacts and details:</p><p style="padding-left:12px; border-left: 2px solid #FF5526;">${selectedText} This is critical for strategic alignment and aligns fully with industry standard practices.</p>`;
                break;
            case 'executive':
                transformedText = `<p>${prefix} Elevated to corporate C-level executive tone:</p><p style="padding-left:12px; border-left: 2px solid #FF5526;">Strategically optimizing the deliverables to maximize overall compliance and technical efficacy: ${selectedText}</p>`;
                break;
            case 'technical':
                transformedText = `<p>${prefix} Upgraded with highly specific technical vocabulary:</p><p style="padding-left:12px; border-left: 2px solid #FF5526;">Architecture design and modular pipeline protocol parameters: ${selectedText}</p>`;
                break;
            case 'bullets':
                const sentences = selectedText.split(/[.!?]+/).filter(s => s.trim().length > 0);
                transformedText = `<ul>` + sentences.map(s => `<li>${s.trim()}</li>`).join('') + `</ul>`;
                break;
            default:
                break;
        }
        if (transformedText) {
            editor.chain().focus().insertContent(transformedText).run();
        }
    };

    return (
        <div className="toolbar-dropdown-container" ref={dropdownRef}>
            <button
                className="toolbar-action-trigger ai-trigger"
                onClick={() => setIsOpen(!isOpen)}
                style={{ background: '#FFF1EC', border: '1px solid #FFF1EC', color: '#FF5526' }}
            >
                <Sparkles size={13} style={{ color: '#FF5526' }} />
                <span>AI Assist</span>
                <ChevronDown size={11} className="chevron-icon" style={{ color: '#FF5526' }} />
            </button>
            {isOpen && (
                <div className="toolbar-dropdown-menu" style={{ width: '200px' }}>
                    {AI_ACTIONS.map((act) => (
                        <button
                            key={act.key}
                            className="toolbar-dropdown-item text-left"
                            onClick={() => handleSelect(act.key)}
                            style={{ textAlign: 'left' }}
                        >
                            {act.label}
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
};

export default AiActionsDropdown;
